"use strict";
exports.__esModule = true;
exports.MenuCtaScope = void 0;
var MenuCtaScope;
(function (MenuCtaScope) {
    MenuCtaScope["Investors"] = "Investors";
})(MenuCtaScope = exports.MenuCtaScope || (exports.MenuCtaScope = {}));
//# sourceMappingURL=header.js.map